module.exports = __webpack_public_path__ + "assets/img/ability30.58bf14f4.png";